import {
  Area,
  AreaChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { Card, CardContent, CardHeader, CardTitle } from "../../ui/card";
import { OverviewEventTimelineProps } from "./interfaces/interface";
import { Skeleton } from "../interfaces/CommonInterfaces";

export default function OverviewEventTimeline({
  fromdetails = false,
  timeline,
  loading,
}: OverviewEventTimelineProps) {
  const noData = !timeline || timeline.length === 0;

  return (
    <Card className="h-full ">
      <CardHeader>
        <CardTitle>Events Timeline</CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex flex-col justify-between h-64">
            {/* Axis + Chart Skeleton */}
            <Skeleton className="w-full h-48 rounded-md" />
            {/* Label skeletons (simulate X-axis ticks) */}
            <div className="flex justify-between mt-2">
              {Array.from({ length: 6 }).map((_, i) => (
                <Skeleton key={i} className="w-8 h-3" />
              ))}
            </div>
          </div>
        ) : noData ? (
          <div className="flex items-center justify-center h-64 text-sm font-medium text-muted-foreground">
            No data found
          </div>
        ) : (
          <div className="h-64">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={timeline}>
                <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
                <XAxis
                  dataKey="date"
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 10 }}
                  className="text-muted-foreground"
                />
                <YAxis
                  axisLine={false}
                  tickLine={false}
                  tick={{ fontSize: 10 }}
                  className="text-muted-foreground"
                />
                <Tooltip
                  labelFormatter={(label) => `Date: ${label}`}
                  formatter={(value) => [value, "Events"]}
                />
                <Area
                  type="monotone"
                  dataKey="events"
                  stroke="hsl(var(--primary))"
                  fill="hsl(var(--primary) / 0.2)"
                  strokeWidth={2}
                  isAnimationActive={false}
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        )}
      </CardContent>
    </Card>
  );
}

